import { IoDownloadOutline } from "react-icons/io5";

const DownloadButton = ({ onDownload, title = "Download Report" }) => {
  return (
    <div>
      <button
        onClick={onDownload}
        className="px-4 py-2 rounded bg-primary text-sm text-white hover:bg-primary/90 transition flex gap-2 items-center cursor-pointer whitespace-nowrap"
      >
        <IoDownloadOutline size={18} />
        {title}
      </button>
    </div>
  );
};

export default DownloadButton;
